import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from '../components/ui/card';

const Services = () => {
  const { t, language } = useLanguage();

  const serviceCategories = [
    {
      title: t('coreEPC'),
      items: [
        language === 'en' ? 'Engineering & Design' : 'الهندسة والتصميم',
        language === 'en' ? 'Civil Works' : 'الأعمال المدنية',
        language === 'en' ? 'MEP Installations' : 'تركيبات MEP',
        language === 'en' ? 'Testing & Commissioning' : 'الاختبار والتشغيل'
      ]
    },
    {
      title: t('supportServices'),
      items: [
        language === 'en' ? 'Procurement' : 'المشتريات',
        language === 'en' ? 'Cost Control' : 'التحكم في التكاليف',
        language === 'en' ? 'Quality Assurance' : 'ضمان الجودة',
        language === 'en' ? 'Safety & HSE' : 'السلامة والصحة والبيئة'
      ]
    },
    {
      title: t('sustainability'),
      items: [
        language === 'en' ? 'Energy Optimization' : 'تحسين الطاقة',
        language === 'en' ? 'Clean Mobility' : 'التنقل النظيف',
        language === 'en' ? 'Renewable Projects' : 'مشاريع الطاقة المتجددة',
        language === 'en' ? 'Decarbonization' : 'إزالة الكربون'
      ]
    },
  ];

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero */}
      <section className="bg-[#141F48] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('servicesTitle')}</h1>
          <p className="text-xl text-[#D3BC8D] font-medium max-w-3xl mx-auto">{t('servicesSubtitle')}</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {serviceCategories.map((category, index) => (
              <Card key={index} className="border-2 border-[#D3BC8D] hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8">
                  <h3 className="text-2xl font-bold text-[#141F48] mb-6 pb-4 border-b-2 border-[#D3BC8D]">
                    {category.title}
                  </h3>
                  <ul className="space-y-4">
                    {category.items.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <CheckCircle2 className="w-5 h-5 text-[#D3BC8D] flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Process Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#141F48] mb-6">
                {language === 'en' ? 'End-to-End EPC Delivery' : 'تسليم EPC الشامل'}
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                {language === 'en' 
                  ? 'From initial concept through to final commissioning, ALMAD provides complete EPC solutions that ensure seamless project execution, quality control, and timely delivery.'
                  : 'من المفهوم الأولي وحتى التشغيل النهائي، توفر ALMAD حلول EPC كاملة تضمن تنفيذ المشروع بسلاسة ومراقبة الجودة والتسليم في الوقت المحدد.'}
              </p>
            </div>
            <div>
              <img
                src="/assets/images/engineers-inspect-the-completed-air-conditioning-a-2024-04-03-02-50-26-utc.jpg"
                alt="EPC Process"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;